import { render, staticRenderFns } from "./ListingDetailsDialog.vue?vue&type=template&id=4a198430&scoped=true&"
import script from "./ListingDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./ListingDetailsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ListingDetailsDialog.vue?vue&type=style&index=0&id=4a198430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a198430",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QToolbar,QIcon,QSpace,QBtn,QTabs,QTab,QTabPanels,QTabPanel,QTable,QSpinner,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QToolbar,QIcon,QSpace,QBtn,QTabs,QTab,QTabPanels,QTabPanel,QTable,QSpinner})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
